import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AppContextService, EcaIconModule, EcaAppShellModule } from '@drc-eca/eca-components-lib';
import { Router, RouterOutlet } from '@angular/router';
import { PortalService } from './core/portal.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EcaIconModule, EcaAppShellModule, RouterOutlet]
})
export class AppComponent implements OnInit {
  private appContextService = inject(AppContextService);
  private portalService = inject(PortalService);
  private router = inject(Router);

  ngOnInit() {
    const url = this.portalService.getPortalUrl(location);
    this.appContextService.setPortalUrl(url);
  }

  onActivate(): void {

    // dependent on eca-app-shell which has <div class="container"> with overflow-y: auto
    const containerElements = document.getElementsByClassName('container');

    if (containerElements && containerElements[0]) {
      containerElements[0].scrollTop = 0;
    }
  }

  logOut(): void {
    this.router.navigateByUrl('/login');
  }
}
